<div>
  <div *ngIf="!notConnected || website?.domain_hash">
    <db-cdn-notice  [websiteId]="website?.id"></db-cdn-notice>
    <db-booster-notices [websiteId]="website?.id"></db-booster-notices>
    <div class="db-settings">

      <div class="db-settings__white-label" *ngIf="website?.connectedFrom === 'speed_optimizer' && currentSubscription
      && (currentSubscription.trialBoosterClient || (currentSubscription.category === UserSubscriptionCategory.PERSONAL
      || currentSubscription.category === UserSubscriptionCategory.PREMIUM
      || currentSubscription.category === UserSubscriptionCategory.ENTERPRISE))">
        <div class="db-settings__items-header">
          <div>
            <h1>
              <span [innerHTML]="'text_whiteLabel' | dbText"></span>
            </h1>
            <p [innerHTML]="'text_settingsWhiteLabelDesc' | dbText"></p>
            <p [innerHTML]="'text_settingsWhiteLabelDesc1' | dbText"></p>
          </div>
        </div>

        <div class="db-settings__items mt15">
          <div class="db-settings__white-label-items" *ngFor="let item of whiteLabelItems">
            <i class="db-icon db-icon-ds-checkmark-bg"></i>
            <span>{{item}}</span>
          </div>
        </div>

        <div *ngIf="currentSubscription && currentSubscription.category !== UserSubscriptionCategory.ENTERPRISE && !currentSubscription.isAgency"
             class="db-settings__upgrade-offer mt30">
          <div>
            <div>
              <h4 *ngIf="!currentSubscription.trialBoosterClient || showPercentOffer">
                <i class="db-icon db-icon-ds-diamond"></i>
                <span [innerHTML]="'text_whiteLabelOffer' | dbText"></span>
              </h4>
              <i *ngIf="currentSubscription.trialBoosterClient && !showPercentOffer" class="db-icon db-icon-ds-diamond"></i>
              <span *ngIf="currentSubscription.trialBoosterClient && !showPercentOffer">
                <b [innerHTML]="'text_whiteLabelOffer' | dbText"></b>
                <div class="mt2" [innerHTML]="'Try 10Web Booster Pro for 7 days for free'"></div>
              </span>
            </div>
          </div>
          <a class="ds-btn-green" (click)="upgrade()">
            <span *ngIf="!loadingApply">{{(currentSubscription.trialBoosterClient && !showPercentOffer ? 'text_tryForFree' : 'text_upgrade') | dbText | lowerCaseSpecificWords}}</span>
          </a>
        </div>

        <div *ngIf="currentSubscription && (currentSubscription.category == UserSubscriptionCategory.ENTERPRISE || currentSubscription.isAgency)"
             class="db-settings__upgrade-offer mt30">
          <div>
            <p>
              <span
                [innerHTML]="'text_whiteLabelAgency' | dbText"></span>
              <a [href]="website?.adminUrl + '?page=two_white_label'" target="_blank"
                 rel="noopener"
                 [innerHTML]="website?.adminUrl + '?advance/whitelabel'"></a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="db-trouble-instructions" *ngIf="notConnected && !website?.domain_hash">
    <div>
      <db-booster-trouble-instructions [insideWebsite]="true" [website]="website" [currentSubscription]="currentSubscription"></db-booster-trouble-instructions>
    </div>
  </div>
</div>
